import { useCallback, useEffect, useState } from 'react';
import { apiService } from '../services/apiService';

const initialState = {
  available: false,
  error: null,
  code: null,
  limiter: null,
  pendingAnalyses: null,
  loading: true,
};

/** Fetches /ai/status; returns { available, error, code, limiter, pendingAnalyses, loading, reload }. */
export default function useAiStatus() {
  const [state, setState] = useState(initialState);

  const reload = useCallback(() => {
    let alive = true;
    setState((prev) => ({ ...prev, loading: true }));
    apiService.ai.getStatus()
      .then((res) => {
        if (!alive) return;
        setState({
          available: !!res.data?.aiServiceStatus?.available,
          error: res.data?.aiServiceStatus?.error || null,
          code: res.data?.aiServiceStatus?.code || null,
          limiter: res.data?.limiter || null,
          pendingAnalyses: res.data?.statistics?.pendingAnalyses ?? null,
          loading: false,
        });
      })
      .catch((e) => {
        if (!alive) return;
        setState({
          available: false,
          error: e.response?.data?.message || 'AI status unavailable',
          code: e.response?.data?.code || null,
          limiter: null,
          pendingAnalyses: null,
          loading: false,
        });
      });
    return () => { alive = false; };
  }, []);

  useEffect(() => reload(), [reload]);

  return { ...state, reload };
}
